import { createContext, useContext, useEffect, useState } from "react";

import { LanguagesApp } from "../hooks/useLanguage/languagesApp";
import { useLanguage } from "../hooks/useLanguage";

import contentAR from "./content.ar.json";
import contentEN from "./content.en.json";
import { IContent } from "./IContent";

type ContextType = {
  content: IContent;
};

type IProps = {
  children: React.ReactNode;
};

const initialValues: ContextType = {
  content: contentEN,
};

export const ContentContext = createContext<ContextType>(initialValues);

export const ContentProvider: React.FC<IProps> = ({ children }) => {
  const { language } = useLanguage();
  const [content, setContent] = useState<any>(contentEN);

  useEffect(() => {
    if (language === LanguagesApp.Arabic) {
      setContent(contentAR);
    } else {
      setContent(contentEN);
    }
  }, [language]);

  return (
    <ContentContext.Provider value={{ content }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const context = useContext(ContentContext);

  if (context === undefined) {
    throw new Error("useContent must be used within a ContentProvider");
  }

  return context.content;
};
